<template>
  <div class="staff-management-item">
    <div class="staff-function">
      <div class="">
        <div class="staff-title">
          <div class="lead">{{staffRole}}</div>
          <div class="staff-filled">{{getterGetStaffAssignList(staffRole).length}}/{{maxValueStaff}} staff filled</div>
        </div>
      </div>
      <div class="group-btn">
        <button class="ap-btn primary" @click="addOrRemoveStaff(staffRole, true)">Add</button>
        <button class="ap-btn destructive" :disabled="(getterGetStaffAssignList(staffRole).length >= maxValueStaff)" @click="addOrRemoveStaff(staffRole, false)">Remove</button>
      </div>
    </div>
    <div class="staff-assign-slot">
      <div class="assign-slots" v-for="(slot, index) in maxValueStaff" :key="index">
        <button class="ap-btn compact"
                :class="{ 'secondary': getStaffAssignName(index) != 'assign',
                          'tertiary': getStaffAssignName(index) == 'assign',
                          'disabled': index > getterGetStaffAssignList(staffRole).length
                        }"
                :disabled="index > getterGetStaffAssignList(staffRole).length || isDisable"
                :id="(staffRole + '_' + index)"
                @click="setOpenAssignModal(staffRole + '_' + index, index)">{{getStaffAssignName(index)}}</button>
        <div class="modal-staff-container" v-if="getterOpenEventStaffModal == (staffRole + '_' + index)">
          <div class="modal-staff-overlay" @click="setOpenAssignModal('')"></div>
          <div class="modal-staff-content" :class="{rightModal : isRightModal(staffRole + '_' + index)}">
            <div class="icon-close" @click="setOpenAssignModal('')"></div>
            <div class="modal-staff-title">assign staff</div>
            <div class="modal-staff-search-box">
              <multiselect v-model="selectedStaff"
                           :options="availableStaffList"
                           placeholder="Find staff member"
                           label="fullName"
                           :openDirection="'below'"
                           :multiple="false"
                           :close-on-select="true"
                           :hide-selected="true"
                           track-by="id" :allow-empty="true"
                           :show-labels="false">
              </multiselect>
            </div>
            <div class="modal-staff-btn-fnc">
              <div class="btn assign" @click="assignStaff(true)">
                <div class="label">assign</div>
              </div>
              <div class="btn unassign" @click="assignStaff(false)">
                <div class="label">unassign</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapActions, mapGetters, mapMutations} from 'vuex';
  import Multiselect from 'vue-multiselect';

  export default {
    name: 'event-detail-staff-management',
    components: {
      Multiselect
    },
    props: {
      staffRole: {
        type: String,
        default: ''
      },
      eventId: {
        type: String,
        default: ''
      },
      maxValueStaff: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        selectedStaff: null,
        availableStaffList: [],
        isDisable: false
      }
    },
    created () {
    },
    methods: {
      addOrRemoveStaff (role, isAdd) {
        this.$emit('add-remove-staff', {
          eventStaffRole: role,
          addStaff: isAdd,
          addStaffScreener: true
        });
      },
      assignStaff (isAssign) {
        if (!this.selectedStaff) {
          this.$toastr('error', 'Please choose one staff to assign!', '');
          return;
        }
        let data = {
          eventId: this.eventId,
          staffId: this.selectedStaff.id,
          assigned: isAssign,
          role: this.staffRole
        };
        this.actionAssignStaff(data).then((response) => {
          if (!response.message) {
            this.$toastr('success', 'Successful!', '');
            this.setOpenAssignModal('');
            this.$emit('assign-successful');
            this.actionGetAllAvailableStaffs({
              eventId: this.eventId,
              role: this.staffRole,
              searchString: ''
            }).then((response) => {
              this.availableStaffList = response.listStaff || [];
            });
          } else {
            this.$toastr('error', response.message, '');
          }
        });
      },
      setOpenAssignModal (key, index = 0) {
        if (index > this.getterGetStaffAssignList(this.staffRole).length) {
          return;
        }
        this.selectedStaff = this.getterGetStaffAssignList(this.staffRole)[index] || {};
        this.saveAssignStaffModalKey(key);
      },
      getOffset (el) {
        const rect = el.getBoundingClientRect();
        return {
          left: rect.left + window.scrollX,
          top: rect.top + window.scrollY
        };
      },
      isRightModal (key) {
        if (key) {
          let dtHeaderEl = document.getElementById('staffing-section');
          let headerWidth = dtHeaderEl.getBoundingClientRect().width;
          let buttonEl = document.getElementById(key);
          let offsetX = this.getOffset(buttonEl).left;
          return (headerWidth - offsetX) < 400;
        }
      },
      getStaffAssignName (index) {
        let assignedStaffList = this.getterGetStaffAssignList(this.staffRole);
        return (assignedStaffList && assignedStaffList[index] && assignedStaffList[index].fullName) || 'assign';
      },
      ...mapActions({
        actionGetAllAvailableStaffs: 'ACTION_GET_ALL_AVAILABLE_STAFFS',
        actionAssignStaff: 'ACTION_ASSIGN_STAFF'
      }),
      ...mapMutations({
        saveAssignStaffModalKey: 'MUTATION_SAVE_ASSIGN_STAFF_MODAL_KEY'
      })
    },
    computed: {
      ...mapGetters({
        getterOpenEventStaffModal: 'GETTER_GET_OPEN_ASSIGN_STAFF_MODAL',
        getterGetStaffAssignList: 'GETTER_GET_STAFF_ASSIGN_LIST'
      })
    },
    mounted () {
      this.eventId = this.$route.params.eventId;
      if (this.eventId) {
        this.actionGetAllAvailableStaffs({
          eventId: this.eventId,
          role: this.staffRole,
          searchString: ''
        }).then((response) => {
          this.availableStaffList = response.listStaff || [];
        });
      }
      this.isDisable = true; // process.env.IS_BING_MAP;
    }
  };
</script>

<style lang="less" scoped>
  @import '../../../styles/variables.less';

  .staff-management-item {
    font-family: 'Open Sans', sans-serif;

    .staff-function {
      display: flex;

      @media only screen and (max-width: 992px) {
        flex-direction: column;
      }
      .staff-title{
        margin-right: 24px;
        display: flex;

        .lead {
          color: #444444;
          font-size: 16px;
          font-weight: bold;
          line-height: 32px;
          text-transform: capitalize;
        }

        .staff-filled {
          color: #424242;
          font-size: 16px;
          line-height: 32px;
          margin-left: 16px;
        }
      }

      .group-btn{
        .ap-btn{
          font-size: 16px;
          font-weight: 600;
          padding: 6px 24px;
          & + .ap-btn {
            margin-left: 8px;
          }
        }
      }
    }

    .staff-assign-slot {
      margin-top: 14px;
      .assign-slots {
        float: left;
        margin-bottom: 8px;
        margin-right: 8px;

        .modal-staff-container {
          position: relative;
          .modal-staff-overlay {
            position: fixed;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            background: black;
            opacity: 0.3;
            z-index: 5;
          }

          .modal-staff-content {
            height: 204px;
            width: 396px;
            border-radius: 4px;
            background-color: #FFFFFF;
            box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.15), 0 8px 8px 1px rgba(0, 0, 0, 0.1);
            position: absolute;
            z-index: 6;
            padding: 24px;
            top: 38px;
            &.rightModal {
              right: 0;
            }
            .modal-staff-title {
              height: 40px;
              width: 250px;
              color: #1D1D1D;
              font-family: "Open Sans", sans-serif;
              font-size: 32px;
              font-weight: 800;
              letter-spacing: -1px;
              line-height: 40px;
              text-transform: uppercase;
            }

            .modal-staff-search-box {
              /*height: 42px;*/
              /*border-radius: 3px;*/
              /*background-color: #882121;*/
              margin-top: 24px;
            }

            .modal-staff-btn-fnc {
              height: 32px;
              margin-top: 17px;
              .unassign {
                background-color: #FF3400;
                height: 100%;
                float: right;
                cursor: pointer;
              }
              .assign {
                background-color: #00A4D6;
                height: 100%;
                float: right;
                margin-left: 8px;
                cursor: pointer;
              }
            }
          }
        }
      }
    }

    .label {
      color: @white;
      font-family: @font-family-main;
      font-size: 16px;
      font-weight: 600;
      letter-spacing: 0.1px;
      line-height: 20px;
      text-transform: uppercase;
      position: relative;
      top: 50%;
      left: 50%;
      float: left;
      transform: translate(-50%, -50%);
    }
    .icon-close {
      margin: 1.5px 1.5px;
      width: 27px;
      height: 27px;
      color: @grey-3;
      background-color: @grey-3;
      -webkit-mask: url('../../../../static/img/action-close.svg') no-repeat center;
      mask: url('../../../../static/img/action-close.svg') no-repeat center;
      background: url('../../../../static/img/action-close-grey.svg');
      position: absolute;
      right: 16px;
      top: 16px;
      &:hover {
        cursor: pointer;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// StaffManagement.vue?336d6431